import { useState } from "react";
import { api, apiError } from "@/lib/api";
import { Plus, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Inline "type and press Enter" creation. Supports shorthand: "!high" / "!urgent", "#issue" / "#request", "@tomorrow" / "@2026-10-20"
export function QuickAdd({ boardId, sectionId, parentId, defaults = {}, onCreated, placeholder = "Add a task — press Enter. Shorthands: !high  #issue  @tomorrow", testid = "quick-add" }) {
  const [v, setV] = useState("");
  const [busy, setBusy] = useState(false);
  const parse = (s) => {
    const out = { ...defaults, title: s };
    s.replace(/!(low|medium|high|urgent)\b/i, (_, p) => { out.priority = p.toLowerCase(); return ""; });
    s.replace(/#(task|issue|request)\b/i, (_, p) => { out.work_type = p.toLowerCase(); return ""; });
    s.replace(/@(today|tomorrow|\d{4}-\d{2}-\d{2})\b/i, (_, d) => { const t = new Date(); if (d === "tomorrow") t.setDate(t.getDate() + 1); out.due_date = /\d{4}/.test(d) ? d : t.toISOString().slice(0, 10); return ""; });
    out.title = s.replace(/!(low|medium|high|urgent)\b/ig, "").replace(/#(task|issue|request)\b/ig, "").replace(/@(today|tomorrow|\d{4}-\d{2}-\d{2})\b/ig, "").replace(/\s+/g, " ").trim();
    return out;
  };
  const submit = async (e) => {
    e.preventDefault(); if (!v.trim()) return; setBusy(true);
    try { const { data } = await api.post("/work/items", { ...parse(v), board_id: boardId || null, section_id: sectionId || null, parent_id: parentId || null }); setV(""); onCreated?.(data); }
    catch (err) { toast.error(apiError(err)); } finally { setBusy(false); }
  };
  return (
    <form onSubmit={submit} className="flex items-center gap-2 px-3 py-2 rounded-xl border border-dashed border-slate-300 bg-white/60 focus-within:border-slate-500 focus-within:bg-white transition-colors" data-testid={testid}>
      {busy ? <Loader2 className="w-4 h-4 text-slate-400 animate-spin" /> : <Plus className="w-4 h-4 text-slate-400" />}
      <input value={v} onChange={(e) => setV(e.target.value)} placeholder={placeholder} className="flex-1 bg-transparent text-sm outline-none placeholder:text-slate-400" data-testid={`${testid}-input`} />
    </form>);
}
